export default (function (siteVars) {
  return {
    meReactingColor: siteVars.accessibleCyan,
    meReactingColorHover: siteVars.accessibleCyan,
    otherReactingColor: siteVars.accessibleYellow,
    otherReactingColorHover: siteVars.accessibleYellow
  };
});